const COOKIE_NAME = 'speRecentlyViewed',
    recentlyViewedProducts = {
        recentViewUpdate: function(productClassIds, productClassId) {
            var max = 24,
                expireInDays = 90,
                arr = productClassIds.slice(0, max - 1);

            arr.unshift(productClassId);

            smartPak.cookie.write(COOKIE_NAME, arr, expireInDays);
        },
        getRecentlyViewedProductClassIds: function() {
            var cookie = smartPak.cookie.read(COOKIE_NAME);
            return cookie ? filterExisting(cookie.split(',')) : null;
        },
        updateRecentlyViewedProductClasses: function(productClassId) {
            if (typeof productClassId === 'undefined') {
                return;
            }

            var productClassIds = this.getRecentlyViewedProductClassIds(),
                ids = productClassIds ? productClassIds : [],
                duplicateIndex = $.inArray(productClassId, ids);

            if (duplicateIndex > -1) {
                ids.splice(duplicateIndex, 1);
            }

            this.recentViewUpdate(ids, productClassId);
        },
        _showBvReviewStars: function(element) {
            var $reviewStars = $(element);

            $reviewStars.removeClass('jsHide');
            $reviewStars.find('svg').removeAttr('style');
        },
        _waitForContainer: function(element, callback) {
            var starContainer = element + ' .bv_stars_button_container';

            waitForElement(starContainer, function() {
                callback(element);
            });
        },
        _displayBvReviews: function(element) {
            this._waitForContainer(
                element,
                function() {
                    var $numReviews = $(element + ' .bv_numReviews_component_container');

                    $numReviews.each(
                        function(index, item) {
                            this._displayBvReviewCount(item);
                        }.bind(this)
                    );

                    this._showBvReviewStars(element);
                }.bind(this)
            );
        },
        _reAddBvElement: function(element) {
            $(element).each(function(index, item) {
                var $item = $(item),
                    hasBvElement = $item.find('.bv_stars_button_container').length > 0,
                    $parent,
                    clone;

                if (!hasBvElement) {
                    $parent = $item.parent();
                    clone = $item.clone();

                    clone.removeClass(element.replace(/\./gi, ''));
                    clone.addClass('restartReviewStars');

                    // Permantly remove and then add the BV div and have the div be activated after added
                    $parent.html('').html(clone);
                    $parent.html('').html(clone);
                }
            });

            this._displayBvReviews('.restartReviewStars');
        },
        _displayBvReviewCount: function(item) {
            var $container = $(item),
                numberOfReviews = $container.find('meta[itemprop="reviewCount"]').attr('content'),
                hasStars = numberOfReviews > 0,
                $reviews = $container.find('.bv_text'),
                reviewCopy = $reviews.attr('aria-label');

            if (hasStars) {
                $reviews.html(reviewCopy);
                $container.parent().removeClass('jsHide');
            } else {
                $container.parent().addClass('jsHide');
            }
        },
        loadBvReviewStars: function(element) {
            this._displayBvReviews(element);

            setTimeout(
                function() {
                    this._reAddBvElement(element);
                }.bind(this),
                2000
            );
        }
    };

function filterExisting(items) {
    return $.grep(items, function(n) {
        return n;
    });
}

function waitForElement(selector, callback) {
    var allowedAttempts = 20,
        timeout = 200,
        attempt = 1;

    function checkForElement() {
        var $element = $(selector);

        if (attempt <= allowedAttempts) {
            if ($element.length) {
                callback($element);
            } else {
                attempt++;
                setTimeout(checkForElement, timeout);
            }
        }
    }

    checkForElement();
}

export default recentlyViewedProducts;
